import React from 'react';
import { useSelector } from 'react-redux'

import AppForm from 'components/Form/AppForm/AppForm'
import { addressInfoForm } from 'FormDefinitions/AddressInfoForm/AddressInfoFormDefinition'
import useAppFormLogic from 'components/Form/AppForm/hooks/useAppFormLogic'
import { AppLinks } from 'enviroment/AppLinks'
import { AppState } from 'store'


/**
 * Strona formularza zbierająca informację o adresie zamieszkania przystosowana do ścieżki wideoweryfikacji
*/
const VideoVerificationAddressInfoFormPage = (): JSX.Element => {
   const { handleVideoVerificationAddressInfoFormSubmitButtonClick } = useAppFormLogic({ form: addressInfoForm })
   const formState = useSelector((state: AppState) => state.formState)
   const appConsents = useSelector((state: AppState) => state.consentsState.appConsents)
   const payingBillCompany = useSelector((state: AppState) => state.applicationState.billingCompany)
   const sessionId = useSelector((state: AppState) => state.videoVerificationState.sessionId)
   

   return ( 
      <AppForm 
         form={{
            ...addressInfoForm, 
            subbmitButtonTextContentPath: 'extendedInfoFormPage.subbmitButtonText',
            previousStepUrlPath: AppLinks.videoVerificationBasicInfoForm,
         }} 
         handleSubmitButtonClick={(e: React.SyntheticEvent) => handleVideoVerificationAddressInfoFormSubmitButtonClick(e, formState, appConsents, { payingBillCompany,  sessionId })} 
      /> 
   )
}

export default VideoVerificationAddressInfoFormPage